// extracted by mini-css-extract-plugin
export default {"root":"w4Ko+","blurb-intro":"Bp09Y"};